import styled from 'vue-styled-components';

var messageProps = {
  reverse: Boolean
};

var primaryInfoMessage = styled('div', messageProps)`
    width: 100%;
    min-height: 40px;
    display: flex;
    align-items: center;
    opacity: 1;
    transition: opacity 120ms ease-in-out;
    font-family: Ubuntu;
    font-style: normal;
    font-size: 16px;
    line-height: 24px;
    font-weight: 300;
    /* identical to box height, or 150% */ 
    color: ${props => props.reverse ? '#ffffff' : '#3E6295'};
    background-color: ${props => props.reverse ? '#64A0C8' : '#E6F9FF'};
    border-radius: 8px;
    
    svg {
        margin: 4px 8px;
        path {
            //fill: ${props => props.reverse ? '#ffffff' : '#3E6295'};
        }
    }

    b, strong {
        font-weight: 500;
    }
    
    & > p {
        padding: 0;
        margin: 0;
    }
    
    a {
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: ${props => props.reverse ? '#ffffff' : '#3E6295'};
        /* identical to box height, or 150% */
        text-decoration-line: underline;
    }
`;

var secondaryInfoMessage = styled('div', messageProps)`
    width: 100%;
    min-height: 40px;
    display: flex;
    align-items: center;
    opacity: 1;
    transition: opacity 120ms ease-in-out;
    font-family: Ubuntu;
    font-style: normal;
    font-size: 16px;
    line-height: 24px;
    font-weight: 300;
    /* identical to box height, or 150% */ 
    color: ${props => props.reverse ? '#FFFFFF' : '#68676C'};
    background-color: ${props => props.reverse ? '#9A9B9C' : '#FCFCFC'};
    border-radius: 8px;
    
    svg {
        margin: 4px 8px;
        path {
            fill: ${props => props.reverse ? '#FFFFFF' : '#68676C'};
        }
    }

    b, strong {
        font-weight: 500;
    }
    
    & > p {
        padding: 0;
        margin: 0;
    }
    
    a {
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: ${props => props.reverse ? '#FFFFFF' : '#68676C'};
        /* identical to box height, or 150% */
        text-decoration-line: underline;
    }
`;

var successMessage = styled('div', messageProps)`
    width: 100%;
    min-height: 40px;
    display: flex;
    align-items: center;
    opacity: 1;
    transition: opacity 120ms ease-in-out;
    font-family: Ubuntu;
    font-style: normal;
    font-size: 16px;
    line-height: 24px;
    font-weight: 300;
    /* identical to box height, or 150% */ 
    color: ${props => props.reverse ? '#FFFFFF' : '#6F8E00'};
    background-color: ${props => props.reverse ? '#8AB100' : '#ECF6CC'};
    border-radius: 8px;
    
    svg {
        margin: 4px 8px;
        path {
            fill: ${props => props.reverse ? '#FFFFFF' : '#6F8E00'};
        }
    }

    b, strong {
        font-weight: 500;
    }
    
    & > p {
        padding: 0;
        margin: 0;
    }
    
    a {
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: ${props => props.reverse ? '#FFFFFF' : '#6F8E00'};
        /* identical to box height, or 150% */
        text-decoration-line: underline;
    }
`;

var warningMessage = styled('div', messageProps)`
    width: 100%;
    min-height: 40px;
    display: flex;
    align-items: center;
    opacity: 1;
    transition: opacity 120ms ease-in-out;
    font-family: Ubuntu;
    font-style: normal;
    font-size: 16px;
    line-height: 24px;
    font-weight: 300;
    /* identical to box height, or 150% */ 
    color: ${props => props.reverse ? '#FFFFFF' : '#F05600'};
    background-color: ${props => props.reverse ? '#F48040' : '#FFE8CC'};
    border-radius: 8px;
    
    svg {
        margin: 4px 8px;
    }

    b, strong {
        font-weight: 500;
    }
    
    & > p {
        padding: 0;
        margin: 0;
    }
    
    a {
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: ${props => props.reverse ? '#FFFFFF' : '#F05600'};
        /* identical to box height, or 150% */
        text-decoration-line: underline;
    }
`;

var errorMessage = styled('div', messageProps)`
    width: 100%;
    min-height: 40px;
    display: flex;
    align-items: center;
    opacity: 1;
    transition: opacity 120ms ease-in-out;
    font-family: Ubuntu;
    font-style: normal;
    font-size: 16px;
    line-height: 24px;
    font-weight: 300;
    /* identical to box height, or 150% */ 
    color: ${props => props.reverse ? '#FFFFFF' : '#B10700'};
    background-color: ${props => props.reverse ? '#DE3831' : '#F8D7D6'};
    border-radius: 8px;
    
    svg {
        margin: 4px 8px;
    }

    b, strong {
        font-weight: 500;
    }
    
    & > p {
        padding: 0;
        margin: 0;
    }
    
    a {
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: ${props => props.reverse ? '#FFFFFF' : '#B10700'};
        /* identical to box height, or 150% */
        text-decoration-line: underline;
    }
`;

var iconPrimaryInfo$1 = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 21c-.767 0-1.516-.069-2.243-.19L4.5 24v-5.31C1.759 16.764 0 13.813 0 10.5 0 4.701 5.372 0 12 0s12 4.701 12 10.5S18.628 21 12 21zm0-19.5c-5.799 0-10.5 4.03-10.5 9 0 3.05 1.775 5.74 4.481 7.368l-.047 3.48 3.531-2.123A12.14 12.14 0 0012 19.5c5.799 0 10.5-4.029 10.5-9 0-4.97-4.701-9-10.5-9zM18 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-6 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-6 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z","fill":"#3E6295"}})]) } };

function prepareMessage(message, component, icon) {
  return {
    message,
    component,
    icon
  };
}

var primaryInfoMessage$1 = ((message, icon = iconPrimaryInfo$1) => prepareMessage(message, primaryInfoMessage, icon));

var iconSecondaryInfo = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 21c-.767 0-1.516-.069-2.243-.19L4.5 24v-5.31C1.759 16.764 0 13.813 0 10.5 0 4.701 5.372 0 12 0s12 4.701 12 10.5S18.628 21 12 21zm0-19.5c-5.799 0-10.5 4.03-10.5 9 0 3.05 1.775 5.74 4.481 7.368l-.047 3.48 3.531-2.123A12.14 12.14 0 0012 19.5c5.799 0 10.5-4.029 10.5-9 0-4.97-4.701-9-10.5-9zM18 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-6 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-6 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z","fill":"#fff"}})]) } };

var secondaryInfoMessage$1 = ((message, icon = iconPrimaryInfo) => prepareMessage(message, secondaryInfoMessage, icon));

var iconSuccess = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"25","height":"21","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24.091 6.312L11.093 19.569a3.02 3.02 0 01-4.333 0l-4.874-4.972a3.168 3.168 0 010-4.418 3.02 3.02 0 014.333 0l2.708 2.761L19.76 1.892a3.022 3.022 0 014.332 0 3.17 3.17 0 010 4.42zM2.924 13.444a1.585 1.585 0 01.046-2.161 1.51 1.51 0 012.165 0l3.792 3.867L20.842 2.997a1.51 1.51 0 012.166 0c.599.61.599 1.6 0 2.21L10.01 18.464a1.51 1.51 0 01-2.166 0s-4.905-5.003-4.92-5.02z"}})]) } };

var successMessage$1 = ((message, icon = iconSuccess) => prepareMessage(message, successMessage, icon));

var iconWarning = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"26","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"M24.381 21.535H1.619a2.112 2.112 0 010-2.988L11.507 1.62a2.111 2.111 0 012.986 0l9.888 16.928a2.112 2.112 0 010 2.988z","stroke":"#F05600","stroke-width":"2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.17 7.585a1.185 1.185 0 00-2.37 0v5.528a1.184 1.184 0 102.37 0V7.585zm-1.178 8.3a1.185 1.185 0 100 2.369 1.185 1.185 0 000-2.37z","fill":"#F05600"}})]) } };

var warningMessage$1 = ((message, icon = iconWarning) => prepareMessage(message, warningMessage, icon));

var iconError = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.25 12c0 5.937 4.814 10.75 10.75 10.75 5.937 0 10.75-4.813 10.75-10.75S17.937 1.25 12 1.25C6.064 1.25 1.25 6.063 1.25 12zm4.679-3.354l9.425 9.425a6.872 6.872 0 01-3.354.871A6.942 6.942 0 015.058 12c0-1.217.317-2.359.87-3.354zm12.124 6.74l-9.44-9.44A6.873 6.873 0 0112 5.059 6.942 6.942 0 0118.942 12c0 1.23-.324 2.383-.889 3.386z","stroke":"#B10700","stroke-width":"1.5"}})]) } };

var errorMessage$1 = ((message, icon = iconError) => prepareMessage(message, errorMessage, icon));

var iconErrorAlt = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.25 12c0 5.937 4.814 10.75 10.75 10.75 5.937 0 10.75-4.813 10.75-10.75S17.937 1.25 12 1.25C6.064 1.25 1.25 6.063 1.25 12zm4.679-3.354l9.425 9.425a6.872 6.872 0 01-3.354.871A6.942 6.942 0 015.058 12c0-1.217.317-2.359.87-3.354zm12.124 6.74l-9.44-9.44A6.873 6.873 0 0112 5.059 6.942 6.942 0 0118.942 12c0 1.23-.324 2.383-.889 3.386z","stroke":"#fff","stroke-width":"1.5"}})]) } };

var iconPrimaryInfoAlt = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 21c-.767 0-1.516-.069-2.243-.19L4.5 24v-5.31C1.759 16.764 0 13.813 0 10.5 0 4.701 5.372 0 12 0s12 4.701 12 10.5S18.628 21 12 21zm0-19.5c-5.799 0-10.5 4.03-10.5 9 0 3.05 1.775 5.74 4.481 7.368l-.047 3.48 3.531-2.123A12.14 12.14 0 0012 19.5c5.799 0 10.5-4.029 10.5-9 0-4.97-4.701-9-10.5-9zM18 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-6 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-6 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z","fill":"#fff"}})]) } };

var iconSecondaryInfoAlt = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 21c-.767 0-1.516-.069-2.243-.19L4.5 24v-5.31C1.759 16.764 0 13.813 0 10.5 0 4.701 5.372 0 12 0s12 4.701 12 10.5S18.628 21 12 21zm0-19.5c-5.799 0-10.5 4.03-10.5 9 0 3.05 1.775 5.74 4.481 7.368l-.047 3.48 3.531-2.123A12.14 12.14 0 0012 19.5c5.799 0 10.5-4.029 10.5-9 0-4.97-4.701-9-10.5-9zM18 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-6 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-6 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z","fill":"#fff"}})]) } };

var iconSuccessAlt = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"25","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24.091 6.312L11.093 19.569a3.02 3.02 0 01-4.333 0l-4.874-4.972a3.168 3.168 0 010-4.418 3.02 3.02 0 014.333 0l2.708 2.761L19.76 1.892a3.022 3.022 0 014.332 0 3.17 3.17 0 010 4.42zM2.924 13.444a1.585 1.585 0 01.046-2.161 1.51 1.51 0 012.165 0l3.792 3.867L20.842 2.997a1.51 1.51 0 012.166 0c.599.61.599 1.6 0 2.21L10.01 18.464a1.51 1.51 0 01-2.166 0s-4.905-5.003-4.92-5.02z","fill":"#fff"}})]) } };

var iconWarningAlt = { render: function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"26","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"M24.381 21.535H1.619a2.112 2.112 0 010-2.988L11.507 1.62a2.111 2.111 0 012.986 0l9.888 16.928a2.112 2.112 0 010 2.988z","stroke":"#fff","stroke-width":"2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.17 7.585a1.185 1.185 0 00-2.37 0v5.528a1.184 1.184 0 102.37 0V7.585zm-1.178 8.3a1.185 1.185 0 100 2.369 1.185 1.185 0 000-2.37z","fill":"#fff"}})]) } };

//
//
//
//
//
//
//
var script = {
  props: {
    messageObject: {
      type: Object,
      required: true
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c(_vm.messageObject.component, {
    tag: "component"
  }, [_vm.messageObject.icon ? _c(_vm.messageObject.icon, {
    tag: "component"
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.messageObject.message) + "\n")], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export { __vue_component__ as Alert, errorMessage$1 as errorMessage, iconError, iconErrorAlt, iconPrimaryInfo$1 as iconPrimaryInfo, iconPrimaryInfoAlt, iconSecondaryInfo, iconSecondaryInfoAlt, iconSuccess, iconSuccessAlt, iconWarning, iconWarningAlt, primaryInfoMessage$1 as primaryInfoMessage, secondaryInfoMessage$1 as secondaryInfoMessage, errorMessage as styledErrorMessage, primaryInfoMessage as styledPrimaryInfoMessage, secondaryInfoMessage as styledSecondaryInfoMessage, successMessage as styledSuccessMessage, warningMessage as styledWarningMessage, successMessage$1 as successMessage, warningMessage$1 as warningMessage };
